// --- SHOPIFY AJAX CART HANDLERS --- //

async function addToCart(variantId, quantity = 1) {
  try {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity }),
    });

    if (!res.ok) throw new Error("Failed to add to cart");

    await res.json();
  } catch (error) {
    console.error("Add to cart failed:", error);
    alert("Something went wrong! Please try again.");
  }
}

async function updateCartItemQty(lineItemKey, newQty) {
  try {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineItemKey, quantity: newQty }),
    });

    const data = await res.json();

    if (!res.ok) throw data;

    return { data };
  } catch (error) {
    console.error("Cart update failed:", error);
    return { error: error.message };
  }
}

async function removeCartItem(lineItemKey) {
  return updateCartItemQty(lineItemKey, 0);
}

async function refreshCart() {
  if (window.location.pathname.includes("/cart")) {
    await refreshMainCart();
    await refreshQuickCart(false);
  } else {
    await refreshQuickCart();
  }

  await refreshMainHeader();
}

async function refreshQuickCart(openCartAfterSave = true) {
  console.count("refreshQuickCart");
  const sectionId = "cart-quick-cart";
  const res = await fetch(`/?section_id=${sectionId}`);
  const data = await res.text();

  // only replace the scrollable content element
  const parser = new DOMParser();
  const doc = parser.parseFromString(data, "text/html");
  const newCartContent = doc.querySelector("#quick-cart-drawer-content");
  const currentCartContent = document.querySelector(
    "#quick-cart-drawer-content"
  );

  if (currentCartContent && newCartContent) {
    currentCartContent.innerHTML = newCartContent.innerHTML;

    if (typeof window.initFlowbite === "function") {
      window.initFlowbite();
      if (openCartAfterSave) {
        document.querySelector(".quick-cart-btn")?.click();
      }
    }
  }
}

async function refreshMainCart() {
  const sectionId = "cart";
  const res = await fetch(`/?section_id=${sectionId}`);
  const data = await res.text();

  // only replace the scrollable content element
  const parser = new DOMParser();
  const doc = parser.parseFromString(data, "text/html");
  const newCartContent = doc.querySelector("#cart-content");
  const currentCartContent = document.querySelector("#cart-content");

  if (currentCartContent && newCartContent) {
    currentCartContent.innerHTML = newCartContent.innerHTML;

    if (typeof window.initFlowbite === "function") {
      window.initFlowbite();
      window?.init_product_slider();
    }
  }
}

async function refreshMainHeader() {
  const sectionId = "header";
  const res = await fetch(`/?section_id=${sectionId}`);
  const data = await res.text();

  // only replace the scrollable content element
  const parser = new DOMParser();
  const doc = parser.parseFromString(data, "text/html");
  const newCartIconWithNumbersWrapper = doc.querySelector(
    "#cart-icon-with-numbers-wrapper"
  );
  const currentCartIconWithNumbersWrapper = document.querySelector(
    "#cart-icon-with-numbers-wrapper"
  );

  if (currentCartIconWithNumbersWrapper && newCartIconWithNumbersWrapper) {
    currentCartIconWithNumbersWrapper.innerHTML =
      newCartIconWithNumbersWrapper.innerHTML;
  }
}

// --- CART QUANTITY HANDLERS --- //

document.addEventListener("DOMContentLoaded", () => {
  // Debounce function to prevent rapid firing of updates
  const debounce = (fn, delay = 500) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn(...args), delay);
    };
  };

  const handleQtyChange = debounce(async (input) => {
    const lineItemKey = input.dataset.itemKey;
    const itemLoading = document.querySelectorAll(
      `.item-loading[data-item-key="${lineItemKey}"]`
    );
    itemLoading.forEach((el) => {
      el.style.display = "block";
    });
    const newQty = Math.max(1, parseInt(input.value) || 1);
    input.value = newQty;
    const { error } = await updateCartItemQty(lineItemKey, newQty);
    await refreshCart();

    if (error) {
      const itemError = document.querySelectorAll(
        `.item-error[data-item-key="${lineItemKey}"]`
      );
      itemError.forEach((el) => {
        el.textContent = error;
        el.style.display = "block";
      });
    }

    itemLoading.forEach((el) => {
      el.style.display = "none";
    });
  }, 500);

  // --- Event Delegation ---
  document.addEventListener("click", async (e) => {
    const plusBtn = e.target.closest(".qty-plus-btn");
    const minusBtn = e.target.closest(".qty-minus-btn");
    const addToCartBtn = e.target.closest(".add-to-cart-btn");
    const removeBtn = e.target.closest(".remote-cart-item-btn");

    // Quantity +/-
    if (plusBtn || minusBtn) {
      e.preventDefault();
      const btn = plusBtn || minusBtn;
      const lineItemKey = btn.dataset.itemKey;
      const inputs = document.querySelectorAll(
        `.product-qty-input[data-item-key="${lineItemKey}"]`
      );
      if (!inputs.length) return;

      const current = parseInt(inputs[0].value) || 1;
      const newValue = plusBtn ? current + 1 : Math.max(1, current - 1);
      inputs.forEach((input) => {
        input.value = newValue;
      });
      handleQtyChange(inputs[0]);
    }

    // Add to Cart
    if (addToCartBtn) {
      e.preventDefault();
      const variantId = addToCartBtn.getAttribute("data-variantId");
      const quantity = parseInt(addToCartBtn.dataset.quantity) || 1;
      const type = addToCartBtn.getAttribute("data-type");

      await addToCart(variantId, quantity);

      if (type === "buy-now") {
        window.location.href = "/checkout";
      } else {
        await refreshCart();
        addToCartBtn.innerText = "Add to Cart";
        addToCartBtn.disabled = false;
      }
    }

    // Remove Item
    if (removeBtn) {
      e.preventDefault();
      const lineItemKey = removeBtn.dataset.itemKey;
      await removeCartItem(lineItemKey);
      await refreshCart();
    }
  });

  // Quantity Input (delegated)
  document.addEventListener("input", (e) => {
    const input = e.target.closest(".product-qty-input");
    if (input) handleQtyChange(input);
  });
});
